(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e) {

  const playBtn = e.target.closest('.petloc-video-play');
  if (playBtn) {

    let videoUrl = playBtn.dataset.videoUrl;

    if(videoUrl.includes('youtu')){
      const videoId = videoUrl.split('v=')[1]?.split('&')[0] 
                      || videoUrl.split('/').pop().split('?')[0];

      videoUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    }

    const popup = document.createElement('div');
    popup.classList.add('video-popup');

    popup.innerHTML = `
      <div class="video-popup__inner">
        <span class="video-popup__close">✕</span>
        <iframe src="${videoUrl}"
          frameborder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen>
        </iframe>
      </div>
    `;

    document.body.appendChild(popup);
  }

  if (e.target.classList.contains('video-popup__close')) {
    e.target.closest('.video-popup').remove();
  }

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }

    closeSearchModal() {
  this.searchModal =
    this.searchModal || this.header.querySelector('details-modal');

  if (this.searchModal) {
    this.searchModal.close(false);
  }
}
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e) {

  const playBtn = e.target.closest('.petloc-video-play');
  if (playBtn) {

    let videoUrl = playBtn.dataset.videoUrl;

    // Detect YouTube URL and convert to embed
    if(videoUrl.includes('youtu')) {
      const videoId = videoUrl.split('v=')[1]?.split('&')[0] 
                      || videoUrl.split('/').pop().split('?')[0];
      videoUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    }

    // Get the wrapper
    const wrapper = playBtn.closest('.petloc-video-cover-wrap');

    // Fade out cover image smoothly
    const coverImg = wrapper.querySelector('.petloc-video-cover');
    coverImg.style.opacity = 0;

    // Remove play button
    playBtn.remove();

    // Insert iframe
    const iframe = document.createElement('iframe');
    iframe.src = videoUrl;
    iframe.frameBorder = 0;
    iframe.allow = "autoplay; encrypted-media";
    iframe.allowFullscreen = true;
    iframe.style.position = 'absolute';
    iframe.style.top = 0;
    iframe.style.left = 0;
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.borderRadius = '20px';

    wrapper.appendChild(iframe);
  }
});

  } catch(e) { console.error(e); }
})();
})();
